import { Route } from '@angular/router';

/**
 * Add this to your app Routes Array to provide your application with the 'auth/login' and 'auth/redirect' routes
 * @example
 * ```ts
 * export const appRoutes: Route[] = [
 *   {
 *    path: 'app',
 *    canActivate: [AppAuthGuard],
 *     loadChildren: () => import('./features/application/application.routes'),
 *   },
 *   lazyLoadedAuthRoutes,
 *   {
 *     path: '**',
 *     redirectTo: 'app',
 *   },
 * ];
 * ```
 */
export const lazyLoadedAuthRoutes: Route = {
  path: 'auth',
  loadChildren: () => import('./auth.routes'),
};
